var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmeraldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.79768C0 1.25257 1.25257 0 2.79768 0H10.7023C12.2474 0 13.5 1.25257 13.5 2.79768V11.25C13.5 14.9779 10.4779 18 6.75 18C3.02208 18 0 14.9779 0 11.25V2.79768Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.449219 2.91855C0.449219 1.61734 1.50406 0.5625 2.80527 0.5625H10.6932C11.9944 0.5625 13.0492 1.61734 13.0492 2.91855V11.25C13.0492 14.7294 10.2286 17.55 6.74922 17.55C3.26982 17.55 0.449219 14.7294 0.449219 11.25V2.91855Z",
    fill: "url(#paint0_linear_1048_23177)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01172 4.9273C1.01172 4.00796 1.75699 3.2627 2.67633 3.2627H10.8221C11.7415 3.2627 12.4867 4.00797 12.4867 4.9273V11.2502C12.4867 14.4189 9.91795 16.9877 6.74922 16.9877C3.58048 16.9877 1.01172 14.4189 1.01172 11.2502V4.9273Z",
    fill: "url(#paint1_linear_1048_23177)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.51172 8.21221L6.74922 7.19971L7.98672 8.21221H5.51172ZM5.51177 8.21221H7.98677V11.3622H5.51177V8.21221ZM6.74927 12.3747L5.51177 11.3622H7.98677L6.74927 12.3747Z",
    fill: "#49F264"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.9624V7.1999L7.9875 8.2124L9.3375 7.59365L6.75 5.9624Z",
    fill: "#2CCC59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.9624V7.1999L5.5125 8.2124L4.1625 7.59365L6.75 5.9624Z",
    fill: "#A3FFC8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.6123V12.3748L7.9875 11.3623L9.3375 11.9811L6.75 13.6123Z",
    fill: "#028D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.6123V12.3748L5.5125 11.3623L4.1625 11.9811L6.75 13.6123Z",
    fill: "#0DB04E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33633 7.59375L7.98633 8.2125V11.3625L9.33633 11.9812V7.59375Z",
    fill: "#0DB04E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16172 7.59375L5.51172 8.2125V11.3625L4.16172 11.9812V7.59375Z",
    fill: "#2CCC59"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_23177",
    x1: 0.701219,
    y1: 1.01229,
    x2: 3.9906,
    y2: 12.8932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1048_23177",
    x1: 6.74922,
    y1: 3.2627,
    x2: 6.74922,
    y2: 16.9877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13855C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#093925"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmeraldIcon);
export default __webpack_public_path__ + "static/media/emeraldIcon.2cdbc56313c08231a4fe3a520fa38792.svg";
export { ForwardRef as ReactComponent };